import React, { useEffect, useState } from 'react';
import { getComponentWiseAvgScore, getComponentById } from '../../services/authService';
import { useParams } from 'react-router-dom';
import { decodeId } from '../../utills/idUtils';

const StrengthsAndWeaknesses = ({ isGeneratingPdf }) => {
  const { encodedId } = useParams();
  const id = decodeId(encodedId)

  const [hiddenStrengths, setHiddenStrengths] = useState([]);
  const [blindSpots, setBlindSpots] = useState([]);

  const fetchApiData = async (id) => {
    try {
      const response = await getComponentWiseAvgScore(id);
      const scores = response.data;
      //console.log("scoress",)

      const processedScores = await Promise.all(
        scores.map(async (score) => {
          const componentDetails = await getComponentById(score.component_id);

          // Check if the score belongs to an initiator or participant
          const isInitiator = score.association_type === 'initiator';
          const selfScore = isInitiator ? parseFloat(score["sum(aua.answer_value)"]) : null;
          const participantScore = isInitiator ? null : parseFloat(score["sum(aua.answer_value)"]); // Get participant score only for participants

          return {
            ...score,
            component_name: componentDetails.component_name,
            description: componentDetails.component_description,
            selfScore: selfScore,
            participantScore: participantScore,
          };
        })
      );

      console.log(processedScores, "processedScores")

      // Process Hidden Strengths
      // 1.  respondent score  resp score >= 4 and differen in both score >=1


      const strengths = processedScores.reduce((acc, score) => {
        if (score.association_type === 'participant') {
          const initiatorScore = processedScores.find(s => s.component_id === score.component_id && s.association_type === 'initiator');
          if (initiatorScore && score.participantScore > initiatorScore.selfScore && (score.participantScore + 2) - (initiatorScore.selfScore + 2) >= 3.2 && score.participantScore + 2 >= 12.8) {
            acc.push({
              title: score.component_name,
              description: score.description,
              selfScore: initiatorScore.selfScore,
              respondentScore: score.participantScore,
              difference: (score.participantScore - initiatorScore.selfScore).toFixed(2),
            });
          }
        }
        return acc;
      }, []);

      console.log("here is the strengths", strengths)
      // Sort strengths by the difference in scores and get top 2
      const sortedStrengths = strengths.sort((a, b) => b.difference - a.difference);
      const topHiddenStrengths = sortedStrengths.slice(0, 2); // Get top 2 hidden strengths

      // Process Blind Spots
      const blindSpotsData = processedScores.reduce((acc, score) => {
        if (score.association_type === 'initiator') {
          const participantScore = processedScores.find(s => s.component_id === score.component_id && s.association_type === 'participant');
          //console.log("participantScore", participantScore)
          if (
            participantScore &&
            score.selfScore > participantScore.participantScore &&
            (score.selfScore + 2) - (participantScore.participantScore + 2) >= 3.2 &&
            score.selfScore + 2 >= 11.2
          ) {
            acc.push({
              title: score.component_name,
              description: score.description,
              selfScore: score.selfScore,
              respondentScore: participantScore.participantScore,
              difference: (score.selfScore - participantScore.participantScore).toFixed(2),
            });
          }
        }
        return acc;
      }, []);

      // Sort blind spots by the difference in scores and get top 2
      const sortedBlindSpots = blindSpotsData.sort((a, b) => b.difference - a.difference);
      const topBlindSpots = sortedBlindSpots.slice(0, 2); // Get top 2 blind spots
      // console.log("topHiddenStrengths", topHiddenStrengths)
      // console.log("topBlindSpots", topBlindSpots)
      // Update state
      setHiddenStrengths(topHiddenStrengths);
      setBlindSpots(topBlindSpots);

    } catch (error) {
      console.error('Error fetching scores or component details:', error);
    }
  };

  useEffect(() => {
    fetchApiData(id);
  }, [id]);

  return (
    <>
      {isGeneratingPdf ? (
        <>

          <div className=" lg:px-16 mt-8">
            <div className="flex flex-wrap bg-[#F0F0F0] rounded-lg" style={{ background: "rgb(230 230 230  / var(--tw-bg-opacity, 1))" }}>

              {
                (hiddenStrengths.length || blindSpots.length) ?
                  <div className=" pt-4 w-full rounded-bl-md rounded-br-md">
                    {hiddenStrengths.length > 0 && (
                      <>
                        <div style={{ pageBreakBefore: "always", breakBefore: "page" }}></div>
                        <div className="">
                          <div
                            className="bg-blue-200 text-black text-lg  font-bold p-2 "
                            style={{ paddingBottom: "5px", fontFamily: "Helvetica" }}
                          >
                            Hidden Strengths:
                            <span className="text-lg font-medium leading-relaxed ml-1">
                              A quality that others consistently see as a strength, but the individual may not fully recognize or leverage.
                            </span>
                          </div>

                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4  ">
                            {hiddenStrengths.length > 0 ? (
                              hiddenStrengths.map((strength, index) => (
                                <div
                                  key={index}
                                  className="bg-green-100 p-4"
                                >



                                  <div className="font-bold text-center">
                                    {strength.title}
                                  </div>
                                  <p className="text-center">{strength.description}</p>
                                  <div className="mt-2 text-center font-bold">
                                    {/* <p><strong>Self Score</strong>: {strength.selfScore}</p> */}
                                    Average Score:{" "}
                                    {(
                                      ((strength.respondentScore + 2) / 16) *
                                      5
                                    ).toFixed(2)}
                                    <span className=" text-gray-500 ml-1">/ 5</span>
                                    {/* <p><strong>Difference In Score</strong>: {strength.difference}</p> */}
                                  </div>
                                </div>
                              ))
                            ) : (
                              <p className="text-center">
                                No hidden strengths available.
                              </p>
                            )}
                          </div>
                        </div>
                      </>
                    )}

                    {/* Blind Spots Section */}
                    {blindSpots.length > 0 && (
                      <>
                        <div
                          style={
                            hiddenStrengths.length === 0
                              ? { pageBreakBefore: "always", breakBefore: "page" }
                              : {}
                          }
                        ></div>

                          <div className="">

                            <div className="bg-blue-200 text-black text-md font-bold p-2">
                              Blind Spots :
                              <span className="text-md font-medium leading-relaxed ml-1">
                                A behavior or trait that others notice but the individual is unaware of.
                              </span>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
                              {blindSpots.length > 0 ? (
                                blindSpots.map((spot, index) => (
                                  <div
                                    key={index}

                                    className={`p-4 rounded-md mb-3  bg-gray-300 
                              `}
                                  // className="bg-green-100 p-4 rounded-lg shadow-md"
                                  >
                                    <div className="font-bold text-center">
                                      {spot.title}
                                    </div>
                                    <p className="text-center">{spot.description}</p>
                                    <div className="mt-2 text-center font-bold ">
                                      {/* <p><strong>Self Score</strong>: {spot.selfScore}</p> */}
                                      Average Score:{" "}
                                      {(((spot.respondentScore + 2) / 16) * 5).toFixed(2)}
                                      <span className="text text-gray-500 ml-1">/ 5</span>
                                      {/* <p><strong>Difference In Score</strong>: {spot.difference}</p> */}
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <p className="text-center">No blind spots available.</p>
                              )}
                            </div>
                          </div>
                        </>
                  )}
                      </div> : null
              }

                  </div>
          </div>
          </>



          ) : (
          <>
            {
              (hiddenStrengths.length || blindSpots.length) ? <div className=" px-4 lg:px-16 mt-8">
                <div className="flex flex-wrap bg-[#F0F0F0] rounded-lg" style={{ background: "rgb(230 230 230  / var(--tw-bg-opacity, 1))" }}>

                  {/* <div className=" pt-4 rounded-bl-md rounded-br-md"> */}
                  <div className=" pt-4 rounded-bl-md rounded-br-md w-full">
                    {hiddenStrengths.length > 0 && (
                      <div className="">
                        <div
                          className="bg-blue-200 text-black text-lg  font-bold p-2 "
                          style={{ paddingBottom: "5px", fontFamily: "Helvetica" }}
                        >
                          Hidden Strengths:
                          <span className="text-lg font-medium leading-relaxed ml-1">
                            A quality that others consistently see as a strength, but the individual may not fully recognize or leverage.
                          </span>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4  ">
                          {hiddenStrengths.length > 0 ? (
                            hiddenStrengths.map((strength, index) => (
                              <div
                                key={index}
                                className="bg-gray-300 p-4"
                              >



                                <div className="font-bold text-center">
                                  {strength.title}
                                </div>
                                <p className="text-center">{strength.description}</p>
                                <div className="mt-2 text-center font-bold">
                                  {/* <p><strong>Self Score</strong>: {strength.selfScore}</p> */}
                                  Average Score:{" "}
                                  {(
                                    ((strength.respondentScore + 2) / 16) *
                                    5
                                  ).toFixed(2)}
                                  <span className=" text-gray-500 ml-1">/ 5</span>
                                  {/* <p><strong>Difference In Score</strong>: {strength.difference}</p> */}
                                </div>
                              </div>
                            ))
                          ) : (
                            <p className="text-center">
                              No hidden strengths available.
                            </p>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Blind Spots Section */}
                    {blindSpots.length > 0 && (
                      <div className="">

                        <div className="bg-blue-200 text-black text-md font-bold p-2">
                          Blind Spots :
                          <span className="text-md font-medium leading-relaxed ml-1">
                            A behavior or trait that others notice but the individual is unaware of.
                          </span>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
                          {blindSpots.length > 0 ? (
                            blindSpots.map((spot, index) => (
                              <div
                                key={index}
                                className="bg-gray-300 p-4 rounded-lg "
                              // className="bg-green-100 p-4 rounded-lg shadow-md"
                              >
                                <div className="font-bold text-center">
                                  {spot.title}
                                </div>
                                <p className="text-center">{spot.description}</p>
                                <div className="mt-2 text-center font-bold ">
                                  {/* <p><strong>Self Score</strong>: {spot.selfScore}</p> */}
                                  Average Score:{" "}
                                  {(((spot.respondentScore + 2) / 16) * 5).toFixed(2)}
                                  <span className="text text-gray-500 ml-1">/ 5</span>
                                  {/* <p><strong>Difference In Score</strong>: {spot.difference}</p> */}
                                </div>
                              </div>
                            ))
                          ) : (
                            <p className="text-center">No blind spots available.</p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div> : null
            }

          </>
      )}
        </>
      );
};

      export default StrengthsAndWeaknesses;
